import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const ProfilePage = () =>
  import('@/apps/adok/pages/profile').then((m) => m.ProfilePage)

const ProfileApiPage = () =>
  import('@/apps/adok/pages/profile-api').then((m) => m.ProfileApiPage)

const ProfileNotificationsPage = () =>
  import('@/apps/adok/pages/profile-notifications').then(
    (m) => m.ProfileNotificationsPage
  )

const ProfileSecurityPage = () =>
  import('@/apps/adok/pages/profile-security').then(
    (m) => m.ProfileSecurityPage
  )

/**
 * The profile is migrating a tab at a time: this file holds the ones that are FSD, and the
 * legacy `/profile/:tab` route in `router.ts` still answers for the rest. It is registered
 * before that one so the tabs listed here win.
 */
const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'profile',
        component: ProfilePage,
        meta: { title: 'Profile' }
      },
      {
        path: 'documents',
        name: 'profile-documents',
        component: ProfilePage,
        meta: { title: 'Company documents', hidden: true }
      },
      {
        path: 'security',
        name: 'profile-security',
        component: ProfileSecurityPage,
        meta: { title: 'Security' }
      },
      {
        path: 'notifications',
        name: 'profile-notifications',
        component: ProfileNotificationsPage,
        meta: { title: 'Notifications' }
      },
      {
        path: 'api',
        name: 'profile-api',
        component: ProfileApiPage,
        meta: { title: 'API' }
      }
    ]
  }
]

export default profileRoutes
